<!-- 增值-提现账号 -->
<template>
  <div class="md-layout">
    <!-- 卡片-设备重复详情表格 -->
    <div class="md-layout-item md-size-100">
      <md-card>
        <!-- 卡片-主体 -->
        <md-card-content>
          <div style="margin-bottom: 10px;">
            <md-button class= "left-icon md-info" @click="addAcc">
              <md-icon>add</md-icon>{{$I18n("add")}}
            </md-button>
          </div>
          <!-- 卡片-主体-表格
            企业名称     银行卡号  银行支行  状态  更新时间  创建时间   编辑
           -->
          <md-table v-model="tableData">
            <md-table-row slot="md-table-row" slot-scope="{ item }" >
              <md-table-cell :md-label="$I18n('company_name')">{{ item.comp_name }}</md-table-cell>
              <md-table-cell :md-label="$I18n('bank_card_num')">{{ item.bank_no }}</md-table-cell>
              <md-table-cell :md-label="$I18n('bank_name')">{{ item.bank_name }}</md-table-cell>
              <md-table-cell :md-label="$I18n('state')">{{ item.state_name }}</md-table-cell>
              <md-table-cell :md-label="$I18n('update_date')">{{ item._update_time }}</md-table-cell>
              <md-table-cell :md-label="$I18n('created_thing_time')">{{ item._create_time }}</md-table-cell>
              <md-table-cell :md-label="$I18n('operate')"  class="button-box">
                <md-button @click.stop @click="editAcc(item)" class="md-just-icon md-round md-info left-icon">
                  <md-icon>edit</md-icon>
                </md-button>
              </md-table-cell>
            </md-table-row>
            <md-table-empty-state slot="md-table-empty-state"> {{$I18n("none_data")}} </md-table-empty-state>
          </md-table>
        </md-card-content>
        <!-- 翻页 -->
        <table-page :total="total" :pageSize="pageSize" v-model="currentPage"/>
      </md-card>
    </div>
    <!-- 弹窗 -->
    <simple-modal ref="modal" :title="modalTitle" :right="true" @submit="modal_submit">
      <!-- 弹窗-主体 -->
      <template slot="body">
        <div>
          <common-form-item 
            v-for="item in form_modalData" 
            v-model="modalData.Form[item.keys]" 
            :error ="modalData.Error[item.keys]" 
            :key="item.keys" v-bind="item"
          />
        </div>
      </template>
    </simple-modal>
  </div>
</template>
<script>
import { FormClass, timestampToString } from "@/common/tools.js";
export default {
  data() {
    return {
      searchForm : { // 表单-筛选表格的查询表单
      },
      searchData : { // API-筛选表格的查询数据
      },
      // 表格相关
      tableInitData : [], // 表格数据
      // compData : [], // 公司数据
      // 分页相关
      pageSize : 10,
      currentPage : 1,
      total : 0,
      // 弹窗相关
      modalTitle : this.$I18n("devdup"),  // 弹窗标题
      // 弹窗表单相关
      modalData : new FormClass({
        name  : "",
        state : 1,
        comp_name : this.UserInfo.comp_name,
        bank_name : "",
        bank_no : "",
      }, {
        name  : "required",
        state : "required",
        bank_name : "required",
        bank_no : "required",
      }),
    };
  },
  mounted : function() {
    this.api_getPageData();
  },
  watch: {
    '$root.state':{
      handler(){
        return 
      },
      immediate: true,
      deep: true,
    },
    currentPage() {
      this.api_getPageData();
    },
  },
  methods: {
    addAcc(){
      this.modalTitle = this.$I18n("add_with_acc")
      this.$refs.modal.open();
      this.modalData.Reset()
    },
    editAcc(item){ // 桌面-修改该数据
      this.modalTitle =  this.$I18n("edit_with_acc")
      this.$refs.modal.open();
      this.modalData.Update({
        ...item,
        comp_name : this.UserInfo.comp_name,
      })
    },
    api_getPageData(){ // API-获取页面信息
      // 获取角色
      let page_no = this.currentPage;
      this.$api.getCompbank({ // api: /iot/uid/duplicate/get
          // ...this.searchData,
          page_size: this.pageSize,
          page_no: this.currentPage,
      })
        .then(this.$Then(res => {
          if (page_no !== this.currentPage) {
            return;
          }
          this.total = res.count;
          this.tableInitData = res.data
        }))
        .catch(this.$Catch(this.$I18n("get_error"),() => {
          this.total = 0;
          this.tableInitData = [];
        }))
    },
    // 提交表单
    modal_submit () {
      if(this.modalData.Check()){
        this.$errorMsg(this.$I18n("pls_check_verify"));
        return 
      }
      if(this.modalTitle == this.$I18n("add_with_acc")){
        this.$api.addCompbank({...this.modalData.Form})
          .then(this.$Then((res) => {
            if(res.code == 9002){
              this.$errorMsg(this.$I18n("error_code_9002"))
              return
            }
            this.$successMsg(this.$I18n("succ_num"));
            this.api_getPageData();
            this.$refs.modal.close();
          },[9002]))
          .catch(this.$Catch(this.$I18n("fail_num")))
      } else {
        this.$api.setCompbank({...this.modalData.Form})
          .then(this.$Then((res) => {
            if(res.code == 9002){
              this.$errorMsg(this.$I18n("error_code_9002"))
              return
            }
            this.$successMsg(this.$I18n("succ_num"));
            this.api_getPageData();
            this.$refs.modal.close();
          },[9002]))
          .catch(this.$Catch(this.$I18n("fail_num")))
      }
    },
  },
  computed: {
    // 表格数据
    tableData(){
      if (!this.tableInitData || this.tableInitData.length === 0){
        return [];
      } else {
        return this.tableInitData.map(i => {
          return {
            ...i,
            state_name: i.state == 1 ?this.$I18n("open") :this.$I18n("closed"),
            _update_time: timestampToString(new Date(i.updated_at).getTime()),
            _create_time: timestampToString(new Date(i.created_at).getTime()),
          }
        });
      }
    },
    form_modalData(){
      return [
        {
          label   : this.$I18n("name"),
          keys    : "name",
          type    : "input",
          required: true,
          check   : true,
        },{
          label   : this.$I18n("state"),
          keys    : "state",
          type    : "select",
          options : [
            {
              id  : 1,
              name: this.$I18n("open"),
            },{
              id  : 2,
              name: this.$I18n("closed"),
            }
          ],
        },{
          label   : this.$I18n("comp_name"),
          keys    : "comp_name",
          type    : "input",
          disabled: true,
        },{
          label   : this.$I18n("bank_name"),
          keys    : "bank_name",
          type    : "input",
          required: true,
          check   : true,
        },{
          label   : this.$I18n("bank_card_num"),
          keys    : "bank_no",
          type    : "input",
          required: true,
          check   : true,
        }
      ];
    },
  },
}
</script>
<style lang="scss" scoped>
  .left-btn {
    text-align:left;
  }
  .md-date-form-item {
    height : 36px;
    border : none;
  }
  .left-table{
    margin-top: 16px;
  }
  .card-form {
    margin-top: 12px;
  }
  // 左侧表单对齐表格
  .left-layout-item{
    padding-rigth:8px;
    padding-left:8px;
  }
  // 表单右侧对齐表格
  .right-layout-item{
    text-align: right;
    padding:0;
  }

  // 弹窗
  .lg-modal .modal-container{
    width : 80%;
    max-width: unset;
  }
  // 表格的ID列
  .numbers {
    width: 160px;
  }
  // 表格的按钮列
  .button-box {
    width: 60px;
  }
  //左侧iocn
  .left-icon{
    margin-left: 16px;
  }
  .md-table .md-table-head:last-child {
    text-align: right;
  }
</style>
